import { render, staticRenderFns } from "./copyPrescriptionDialog.vue?vue&type=template&id=48bb2315&scoped=true&"
import script from "./copyPrescriptionDialog.vue?vue&type=script&lang=ts&"
export * from "./copyPrescriptionDialog.vue?vue&type=script&lang=ts&"
import style0 from "./copyPrescriptionDialog.vue?vue&type=style&index=0&id=48bb2315&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bb2315",
  null
  
)

export default component.exports